import type { RouteObject } from "react-router-dom";
import { helperPathname } from "#src/config/pathname";
import { msspPentestRoute } from "./pentest";
import { msspBugBountyRoute } from "./bugBounty";

export const msspRoute: RouteObject = {
  path: helperPathname.MSSP,
  children: [msspPentestRoute, msspBugBountyRoute],
};
